const API_BASE_HOST = 'http://api.internal.casiostore.com.cn/admin'
// const API_BASE_HOST = 'http://api.internal-purchase.test.xcxd.ltd/admin'
// // const API_BASE_HOST = 'http://192.168.2.75:8086/admin'


export default {

  title: API_BASE_HOST.indexOf('test') > -1 ? '卡西欧特卖测试系统管理后台' : '卡西欧特卖系统管理后台',

  api: {
    limit: 20,
    baseURL: API_BASE_HOST,

  },
  envTag: API_BASE_HOST.indexOf('test') > -1 ? '测试站' : '正式站',
  client: {
    web: {
      baseUrl: 'http://internal.casiostore.com.cn',
      // baseUrl: 'http://internal-purchase.test.xcxd.ltd',
    },
    admin: {
      baseUrl: 'http://localhost:8081',
    },
  }
}
